import React, { useContext } from "react";
import { Badge, IconButton } from "@mui/material";

import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";

import { cacheService, messengerNotifier, messengerService } from "../../../../Core/Api/services";
import { EventNotifierOperation } from "../../../../Core/Api/notifier-client";
import {
  NewMessage,
  GetUnreadMessages,
  DeleteGroupMessage,
  AddGroupMessage,
  DeleteMessage,
  SetMessageBadgeNumber,
} from "../../../../Redux/Reducers/redux-slice-group-messages";
import { useDispatch, useSelector } from "react-redux";
import { routePaths } from "../../../../Router/router";
import { useNavigate } from "react-router";
import { HubConnectionState } from "@microsoft/signalr";

export interface PageHeadCommentsProps {}

const PageHeadComments: React.FC<PageHeadCommentsProps> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const unreadMessages = useSelector(GetUnreadMessages);
  const authId = React.useMemo(() => cacheService.GetUserInfo()!.id, []);

  React.useEffect(() => {
    if (
      !messengerNotifier ||
      !messengerNotifier.connection ||
      messengerNotifier.connection.state !== HubConnectionState.Connected
    ) {
      // First load to get conversations groups
      messengerService.ListGroups().then(function (response) {
        if (response.groups) {
          let counter: number = 0;
          response.groups.forEach((element) => {
            if (!element.reads?.map((user) => user.userId).includes(authId)) counter++;
          });
          dispatch(SetMessageBadgeNumber(counter));
        }
      });

      // Subscribe to websocket events
      messengerNotifier.Connect().then(function () {
        console.info("::messenger socket connected!");

        if (messengerNotifier.connection) {
          messengerNotifier.connection.on("ChatMessage", (data) => {
            switch (data.op) {
              case EventNotifierOperation.Create:
                if (data.data.type === "Group") dispatch(AddGroupMessage(data.data));
                if (data.data.type === "Message") dispatch(NewMessage(data.data));
                break;
              case EventNotifierOperation.Update:
                break;
              case EventNotifierOperation.Delete:
                if (data.data.type === "Group") dispatch(DeleteGroupMessage(data.data.id));
                if (data.data.type === "Message")
                  dispatch(DeleteMessage({ groupId: data.data.groupId, messageId: data.data.id }));
                break;
            }
          });
        }
      });
    }
    /*return function cleanup() {
      // Disconnect hub when dismounted
      messengerNotifier.Disconnect().then(function () {});
    };*/
  }, []);

  return (
    <IconButton color="ghost" onClick={() => navigate(routePaths.dashboardConversations.path)} size="small">
      {unreadMessages > 0 ? (
        <Badge badgeContent={unreadMessages} color="info">
          <QuestionAnswerOutlinedIcon />
        </Badge>
      ) : (
        <QuestionAnswerOutlinedIcon />
      )}
    </IconButton>
  );
};

export default PageHeadComments;
